import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
})
export class ClientComponent implements OnInit, AfterViewInit {
  constructor(public configService: ConfigService) {
    sessionStorage.clear();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const dateFrom = new Date('2023-01-13').getTime();
    const dateTo = new Date('2023-01-31').getTime();
    const currentDate = new Date().getTime();

    if (currentDate >= dateFrom && currentDate <= dateTo) {
      setTimeout(() => {
        const snackbar = document.getElementById('snackbar');
        if (snackbar) {
          // Add the "show" class to DIV
          snackbar.className = 'show';
          sessionStorage.setItem('displaySnackbar', new Date().getTime() + '');
          // After 5 seconds, remove the show class from DIV
          setTimeout(() => {
            snackbar.className = snackbar.className.replace('show', '');
          }, 10000);
        }
      }, 1000);
    }
  }

  closeSnackbar() {
    const snackbar = document.getElementById('snackbar');
    snackbar.className = snackbar.className.replace('show', '');
  }
}
